var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.243 0h35.514C38.996 0 40 .992 40 2.215v19.57C40 23.008 38.996 24 37.757 24H2.243C1.004 24 0 23.008 0 21.785V2.215C0 .992 1.004 0 2.243 0z",
    fill: "#006FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.241 16.44v-1.773L3.92 7.19h10.867l1.097 2.043 1.025-2.043H31.56l1.252 1.27 1.345-1.27h5.602v1.148l-3.629 3.467 3.629 3.64v.995h-5.591l-1.473-1.362-1.461 1.362H7.73l-.707-1.458H5.778l-.643 1.458z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.027 15.08H5.774h1.253zm13.927-6.568h-2.862l-2.153 4.427-2.316-4.427H10.76v6.409L7.804 8.51H5.12L1.958 15.12h1.935l.64-1.506h3.68l.736 1.506h3.556V9.741l2.521 5.378h1.663l2.507-5.286v5.286h1.758V8.512zm11.814 2.14l-2.044-2.14h-8.203v6.607h7.93l2.25-2.167 2.261 2.167h2.112l-3.23-3.343 3.326-3.264h-2.208l-2.194 2.14zm-4.32 3.146h-4.17v-1.454h4.17v-1.321h-4.17v-1.19h4.17V8.71l3.094 3-3.093 3.013v-.925zM6.415 9.595l1.2 2.683H5.12l1.294-2.683z",
    fill: "#006FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.005v19.99A1.5 1.5 0 0 0 1.997 23.5h36.006a1.5 1.5 0 0 0 1.497-1.505V2.005A1.5 1.5 0 0 0 38.003.5H1.997A1.5 1.5 0 0 0 .5 2.005zm-.5 0A2 2 0 0 1 1.997 0h36.006A2 2 0 0 1 40 2.005v19.99A2 2 0 0 1 38.003 24H1.997A2 2 0 0 1 0 21.995V2.005z",
    fill: "#BEC8D2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.9bedec39847b530c6410260ab37d1bf0.svg";
export { ForwardRef as ReactComponent };